import { render, staticRenderFns } from "./ProcesoTabPreguntas.vue?vue&type=template&id=412c79a2&"
import script from "./ProcesoTabPreguntas.vue?vue&type=script&lang=js&"
export * from "./ProcesoTabPreguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports